export default __webpack_public_path__ + "static/media/track-night.bcac670f.svg";